import React, { useState } from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';

const FAQItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div
            className="mb-4 cursor-pointer"
            onClick={() => setIsOpen(!isOpen)}
        >
            <div className="flex justify-between items-center font-semibold text-left">
                {question}
                <span className="ml-2">
                    {isOpen ? <FaTimes /> : <FaPlus />}
                </span>
            </div>
            {isOpen && <p className="text-gray-600 mt-2 text-left">{answer}</p>}
            <hr className="border-t border-gray-200 mt-2" />
        </div>
    );
};

const FAQ = () => (
    <section className="my-10 px-4 md:px-10 lg:px-20">
        <h2 className="text-3xl font-semibold mb-4 text-center" style={{ fontFamily: '"Courier Prime", monospace' }}>Fragen und Antworten</h2>
        <div className="bg-white p-6 rounded-lg shadow-md max-w-3xl mx-auto">
            <FAQItem
                question="Wie lange dauert es, das 10-Finger-Schreiben zu lernen?"
                answer="Die Dauer, um das 10-Finger-Schreiben zu erlernen, variiert je nach individuellem Lernfortschritt und Übungshäufigkeit. Im Durchschnitt benötigen die meisten Menschen etwa 2 bis 4 Wochen regelmäßiges Training, um die Grundlagen zu beherrschen."
            />
            <FAQItem
                question="Gibt es eine Pro-Version und was sind ihre Vorteile?"
                answer="Ja, es gibt eine Pro-Version. Diese bietet erweiterte Funktionen wie detaillierte Fortschrittsanalysen, personalisierte Trainingspläne und Zugang zu exklusiven Übungen und Tipps."
            />
            <FAQItem
                question="Wie viel kostet die Pro-Version?"
                answer="Die Pro-Version kostet 9,99 € pro Monat oder 99,99 € pro Jahr. Es gibt auch gelegentlich Rabatte und Angebote."
            />
            <FAQItem
                question="Welche Zahlungsmethoden werden akzeptiert?"
                answer="Wir akzeptieren verschiedene Zahlungsmethoden, darunter Kreditkarten, PayPal und andere gängige Online-Zahlungsdienste."
            />
            <FAQItem
                question="Ist das 10-Finger-Schreiben für Kinder geeignet?"
                answer="Ja, das 10-Finger-Schreiben ist für Kinder geeignet und kann ihnen helfen, frühzeitig effiziente Schreibfähigkeiten zu entwickeln, die ihnen in der Schule und im späteren Leben zugutekommen."
            />
            <FAQItem
                question="Wie kann ich meinen Fortschritt verfolgen?"
                answer="Mit unserem Fortschrittstracker können Sie Ihre Tippgeschwindigkeit, Genauigkeit und andere wichtige Metriken überwachen. Dies ist in der Pro-Version enthalten."
            />
            <FAQItem
                question="Kann ich das 10-Finger-Schreiben auf jedem Gerät lernen?"
                answer="Ja, unsere Plattform ist webbasiert und funktioniert auf den meisten Geräten mit Internetzugang, einschließlich Computern, Tablets und Smartphones."
            />
            <FAQItem
                question="Wie kann ich den Support kontaktieren?"
                answer={(
                    <span>
                        Wenn Sie Fragen oder Probleme haben, können Sie unseren Support per E-Mail unter <a href="mailto:support@10-finger-schreiben-lernen.de" className="text-blue-600 underline">support@10-finger-schreiben-lernen.de</a> erreichen. Wir helfen Ihnen gerne weiter.
                    </span>
                )}
            />
        </div>
    </section>
);

export default FAQ;
